
const prefix = 'STAFF_';

export const staffConstants = {
    UPDATE_STAFF_LIST: prefix + 'UPDATE_STAFF_LIST',
    UPDATE_STAFF_LIST_RESPONSE: prefix + 'UPDATE_STAFF_LIST_RESPONSE'
};
